import React, { useState } from 'react';
import Icon from 'components/icons';
import { hideModal } from 'store/modal/actions';
import { useDispatch } from 'react-redux';
import { PrimaryModalButton } from 'components/Button';
import { DesignItForMeRadioTile } from './DesignItForMeRadioTile';
import * as styles from './styles.module.scss';
import { DeviceSize, useWindowSize } from '../../../../../hooks/useWindowSize';
import { getGatsbySiteUrl } from 'helpers/env';

interface ModalProps {
  onAutofill: () => void;
}

enum DesignType {
  AUTOFILL,
  WORK_WITH_SPECIALIST
}

enum DesignTypeImage {
  AUTOFILL_DESKTOP = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/design-it-for-me-autofill-desktop.png',
  AUTOFILL_MOBILE = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/design-it-for-me-autofill-mobile.png',
  SPECIALIST_DESKTOP = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/design-it-for-me-specialist-desktop.png',
  SPECIALIST_MOBILE = 'https://au-prod-media.s3.us-west-2.amazonaws.com/media/design-it-for-me-specialist-mobile.png'
}

export const DesignItForMeModal = ({
  onAutofill
}: ModalProps): React.JSX.Element => {
  const dispatch = useDispatch();

  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;

  const [designType, setDesignType] = useState<DesignType>(DesignType.AUTOFILL);

  const handleClose = () => {
    dispatch(hideModal());
  };

  const handleSubmit = () => {
    if (designType === DesignType.AUTOFILL) {
      onAutofill();
    } else {
      window.open(`${getGatsbySiteUrl()}/album-design-service`);
    }
    handleClose();
  };

  const autofillImageSrc = isMobile
    ? DesignTypeImage.AUTOFILL_MOBILE
    : DesignTypeImage.AUTOFILL_DESKTOP;

  const specialistImageSrc = isMobile
    ? DesignTypeImage.SPECIALIST_MOBILE
    : DesignTypeImage.SPECIALIST_DESKTOP;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4>Design It For Me</h4>
        <Icon
          className={styles.closeButton}
          onClick={handleClose}
          icon="close"
          size="small"
        />
      </div>

      <div className={styles.body}>
        <DesignItForMeRadioTile
          name="design-type"
          value={DesignType.AUTOFILL}
          title="Autofill Your Book"
          price="FREE"
          description="Your photos will be added to each page in chronological order, using our most popular page layouts. Then you can make adjustments. If you don’t love it, just hit undo."
          image={autofillImageSrc}
          checked={designType === DesignType.AUTOFILL}
          onChange={() => setDesignType(DesignType.AUTOFILL)}
        />

        <DesignItForMeRadioTile
          name="design-type"
          value={DesignType.WORK_WITH_SPECIALIST}
          title="Work with a Design Specialist"
          price="$99 design fee + $100 deposit"
          description="Let one of our in-house experts design your photo book for you. You get to choose the photos and make final revisions—we’ll handle the rest."
          image={specialistImageSrc}
          checked={designType === DesignType.WORK_WITH_SPECIALIST}
          onChange={() => setDesignType(DesignType.WORK_WITH_SPECIALIST)}
        />

        <div className={styles.buttonContainer}>
          <PrimaryModalButton id="get-started" onClick={handleSubmit}>
            Get Started
          </PrimaryModalButton>
        </div>
      </div>
    </div>
  );
};
